<template>
  <div class="repair-status-item-header">
    <div>
      <p class="repair-status-item-header__title">
        {{ '№ ' + response?.repairNumber }}
        <!--                № 33276 від 17.12.2022-->
      </p>
      <p class="repair-status-item-header__text">
        {{ response?.name }}
      </p>
    </div>
    <div>
      <p class="repair-status-item-header__title">
        {{ messages.service }}
      </p>
      <p class="repair-status-item-header__text">
        {{ messages.repair }}
      </p>
    </div>
    <div class="repair-status-product">
      <img :src="picture?.src" :alt="picture?.src" class="repair-status-product__image" />
      <p class="repair-status-product__text">
        {{ response?.product?.name }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const { result } = defineProps(['result']);
const response = computed(() => result?.response);
const messages = computed(() => result?.messages);
const picture = computed(() => result?.response?.product?.picture);
</script>

<script>
export default {
  name: 'RepairStatusItemHeader',
};
</script>

<style lang="scss" scoped>
.repair-status-item-header {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  border-left: 5px solid #efe6cc;
  margin: 16px 16px 0;
  padding-left: 24px;
  @include point-md {
    grid-template-columns: repeat(2, 0.8fr) 1fr;
  }
  @include point-lg {
    grid-template-columns: repeat(3, 1fr);
  }
  &__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
    color: #5f5f67;
    margin-bottom: 6px;
  }
  &__text {
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
    margin-bottom: 0;
  }
}
.repair-status-product {
  display: grid;
  grid-template-columns: 42px 1fr;
  grid-column-gap: 10px;
  &__image {
    display: block;
    width: 42px;
  }
  &__text {
    font-weight: 500;
    font-size: 14px;
    line-height: 125%;
  }
}
</style>
